<template>
  <b-row id="content">
    <!-- Right hand side filters -->
    <MainFilterPanel
      v-on:update-filters="updateFilters"
      v-on:change-category="changeCategory"
      :availableColors="availableColors"
      :availableProducts="availableProducts"
      :initialAvailableProducts="initialAvailableProducts"
      v-if="loaded"
    />
    <!-- Products area -->
    <ProductsArea
      v-on:clear-all="clearAll"
      v-on:remove-filter="removeFilter"
      v-on:change-sort="changeSort"
      :appliedFilters="appliedFilters"
      :availableProducts="availableProducts"
      :resultsNum="availableProducts.length"
      v-if="loaded"
    />
  </b-row>
</template>

<script>
import MainFilterPanel from "../common-components/MainFilterPanel";
import ProductsArea from "../common-components/ProductsArea";
export default {
  name: "ContentSection",
  props: ["theme"],
  components: {
    MainFilterPanel,
    ProductsArea,
  },
  methods: {
    updateFilters(f) {
      this.appliedFilters = f;
      this.getProducts();
    },
    changeSort(sort) {
      this.sortBy = sort;
      this.getProducts();
    },
    removeFilter(filterIndex) {
      this.appliedFilters.splice(filterIndex, 1);
      this.getProducts();
    },
    clearAll() {
      this.appliedFilters.splice(0);
    },
    getProducts() {
      this.$axios
        .get("products", {
          params: {
            theme: this.theme.name,
            category: this.selectedCat,
            colors: this.appliedFilters.toString(),
          },
        })
        .then((res) => {
          if (this.initialAvailableProducts.length == 0) {
            this.initialAvailableProducts = res.data.data;
          }
          this.availableProducts = res.data.data;
          this.resultsNum = res.data.total;
          if (this.appliedFilters.length == 0) {
            
            this.availableProducts.forEach((product) => {
                 if (product.Colour != "") {
                const productColors = product.Colour.split("/");
                for (const productColor of productColors) {
                  if (productColor != "") {
                    this.availableColors.add(productColor);
                  }
                }
              }
              if (product.colors) {
                for (const productColor of product.colors) {
                  if (productColor.Colour != "") {
                    this.availableColors.add(productColor.Colour);
                  }
                }
              }
            });
          }
          this.loaded = true;
        });
    },
  },
  data() {
    return {
      selectedCat: null,
      appliedFilters: [],
      availableProducts: {},
      initialAvailableProducts: [],
      availableColors: new Set(),
      loaded: false,
    };
  },
  mounted() {
    this.getProducts();
  },
};
</script>

<style scoped>
#content {
  min-height: 66vh;
  padding: 1rem !important;
}
</style>
